export function formatDate(isoDate: string, locale: string = "de-DE"): string {
    return new Intl.DateTimeFormat(locale, { day: "2-digit", month: "long", year: "numeric" }).format(new Date(isoDate));
}
